import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, ArrowUpRight } from 'lucide-react';
import { siteData } from '../mock/data';
import LogoMark from './LogoMark';

const Footer = () => {
  const { company, nav } = siteData;
  const year = new Date().getFullYear();
  return (
    <footer className="relative dark-section radial-glow pt-28 pb-10 overflow-hidden">
      <div className="container-x relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-14 pb-20">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3 mb-8">
              <LogoMark size={48} />
              <div>
                <div className="font-display text-2xl leading-none">Aurelian <span className="font-serif-italic text-[#BFA070]">Heights</span></div>
                <div className="font-mono-up text-[9px] text-[#E8E2D5]/60 mt-1">Luxusimmobilienverwaltung</div>
              </div>
            </div>
            <div className="font-mono-up text-[#BFA070] mb-6">
              <span className="gold-line" />Ihr Partner
            </div>
            <h3 className="font-display text-5xl md:text-6xl leading-[0.98] mb-10">
              Werte schaffen.<br />
              <span className="font-serif-italic text-[#BFA070]">Werte erhalten.</span>
            </h3>
            <Link to="/kontakt" className="lux-btn lux-btn-light">
              <span>Gespräch vereinbaren</span>
              <ArrowUpRight className="arrow" size={16} strokeWidth={1.5} />
            </Link>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-up text-[#BFA070]/80 mb-5">Navigation</div>
            <ul className="space-y-3">
              {nav.map((i) => (
                <li key={i.path}>
                  <Link to={i.path} className="link-underline font-display text-2xl text-[#E8E2D5]/90 hover:text-[#BFA070]">
                    {i.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <div className="font-mono-up text-[#BFA070]/80 mb-5">Kontakt</div>
            <div className="space-y-4 text-[15px]">
              <a href={`tel:${company.phoneHref}`} className="flex items-center gap-3 text-[#E8E2D5]/90 hover:text-[#BFA070] transition-colors">
                <Phone size={16} strokeWidth={1.25} />
                <span>{company.phone}</span>
              </a>
              <a href={`mailto:${company.email}`} className="flex items-center gap-3 text-[#E8E2D5]/90 hover:text-[#BFA070] transition-colors">
                <Mail size={16} strokeWidth={1.25} />
                <span>{company.email}</span>
              </a>
              <div className="flex items-start gap-3 text-[#E8E2D5]/80 leading-relaxed">
                <MapPin size={16} strokeWidth={1.25} className="mt-1" />
                <div>
                  <div>{company.address.line1}</div>
                  <div>{company.address.line2}</div>
                  <div>{company.address.line3}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Slim divider instead of giant logotype */}
        <div className="border-t border-[#E8E2D5]/10 pt-10" />

        <div className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between text-[12px] tracking-[0.2em] uppercase text-[#E8E2D5]/55">
          <div>© {year} Aurelian Heights Luxusimmobilienverwaltung GmbH</div>
          <div className="flex gap-8">
            <a href="#" className="hover:text-[#BFA070] transition-colors">Impressum</a>
            <a href="#" className="hover:text-[#BFA070] transition-colors">Datenschutz</a>
            <a href="#" className="hover:text-[#BFA070] transition-colors">AGB</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
